/**
 * Guarda de tokens JWT, UMA SESSÃO POR HUB desde 03/11/2026.
 * - access: só em memória (não persiste — reduz superfície de XSS).
 * - refresh: em localStorage, para sobreviver a reloads (TTL 7 dias no backend).
 * O bootstrap troca o refresh por um access novo ao subir a app.
 *
 * Cada hub tem a própria sessão, e todo método fala da sessão do hub DA ABA
 * (`core/hubs/hubs.ts`). O HubTransGrãos continua na chave de sempre, `tg.refresh`:
 * quem já estava logado segue entrando direto, sem refazer o login. A Farm guarda a
 * dela em `hvf.refresh`, e entrar lá nunca reaproveita a do outro hub.
 */
import { hubLembrado, type HubKey } from '../hubs/hubs'

const REFRESH_KEY: Record<HubKey, string> = {
  transgraos: 'tg.refresh',
  farm: 'hvf.refresh',
}

const accessPorHub: Record<HubKey, string | null> = { transgraos: null, farm: null }

export const tokenStore = {
  getAccess(): string | null {
    return accessPorHub[hubLembrado()]
  },
  setAccess(token: string | null): void {
    accessPorHub[hubLembrado()] = token
  },
  getRefresh(): string | null {
    try {
      return localStorage.getItem(REFRESH_KEY[hubLembrado()])
    } catch {
      return null
    }
  },
  setRefresh(token: string | null): void {
    try {
      const chave = REFRESH_KEY[hubLembrado()]
      if (token) localStorage.setItem(chave, token)
      else localStorage.removeItem(chave)
    } catch {
      /* storage indisponível (modo privado) — segue só em memória */
    }
  },
  set(access: string, refresh: string): void {
    this.setAccess(access)
    this.setRefresh(refresh)
  },
  /** Encerra só a sessão do hub da aba: sair da Farm não derruba o HubTransGrãos. */
  clear(): void {
    accessPorHub[hubLembrado()] = null
    this.setRefresh(null)
  },
  hasSession(): boolean {
    return Boolean(this.getAccess() || this.getRefresh())
  },
}
